import { render } from "./gameDetail.vue?vue&type=template&id=774fb9ad&scoped=true"
import script from "./gameDetail.vue?vue&type=script&lang=js"
export * from "./gameDetail.vue?vue&type=script&lang=js"

import "./gameDetail.vue?vue&type=style&index=0&id=774fb9ad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774fb9ad"]])

export default __exports__